












import {Component} from 'vue-property-decorator'
import {AdEditForm} from "@/module/ad/AdvertisementApi";
import AdSaveDialog from "@/view/ad-manage/ad/save-dialog.vue";

@Component({
  components: {AdSaveDialog}
})
export default class AdEditDialog extends AdSaveDialog {

  private f = new AdEditForm()

  private async editAd() {
    await this.api.edit(this.f)
  }

  openAd(form: AdEditForm) {
    this.f = form
    this.dialog.open()
  }
}
